import React from "react";

// Animations
import { TypeAnimation } from "react-type-animation";
import { Fade } from "react-reveal";

import "./FooterStyles.css";
import { FooterData } from "./FooterData";

function Footer(props) {

    return (
        <>
            <div className="footer footer-shadow">
                <div>
                    <TypeAnimation
                        sequence={[
                            '',props.width > 600 ? 300 : 800, 'Stone Culver', 1500
                        ]}
                        speed={30}
                        cursor={false}
                        style={{
                            fontFamily: 'Daydream',
                            fontWeight: '800',
                            color: '#251a12',
                        }}
                        className={'footer-header'}
                    />
                </div>

                <ul className="footer-lists">
                    {FooterData.map((item, index) => {
                        return (
                            <li key={index}>
                                <TypeAnimation
                                    sequence={[
                                        '', props.width > 600 ? 500 : 1000, item.title, 1500
                                    ]}
                                    speed={30}
                                    cursor={false}
                                    style={{
                                        fontFamily: 'Daydream',
                                        fontWeight: '800',
                                    }}
                                    className={'footer-list-label'}
                                />
                                <ul className="internal-footer-list">
                                    {item.links.map((internalItem, internalIndex) => {
                                        return (
                                            <li key={index}>
                                                <a href={internalItem.url} className={internalItem.cName}>
                                                    <i className={internalItem.icon}></i> {internalItem.title}
                                                </a>
                                            </li>
                                        )
                                    })
                                    }
                                </ul>
                            </li>
                        )
                    })
                    }
                </ul>
                <div>
                    <p className="bottom-text">Website Made With Love by Stone Culver using React <i className="fa-regular fa-heart" i /></p>
                </div>
            </div>
        </>
    )
}

export default Footer;